import { ReactElement } from 'react';
import { UsersTable } from './UsersTable';
import { Stack, Typography } from '@mui/material';
import { SearchStringFilter } from './SearchStringFilter';
import { FilterOptions } from './FilterOptions';
import { ManageUserActions } from './ManageUserActions';

export const Table = (): ReactElement => {
  return (
    <Stack>
      <Stack direction="row" gap={1} alignItems="center" justifyContent="space-between" pb={1}>
        <Stack direction={'row'} gap={1} alignItems="center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Typography fontSize={24}>Users</Typography>
        </Stack>
        <ManageUserActions />
      </Stack>
      <Stack
        direction="row"
        gap={4}
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Stack width={'50%'}>
          <SearchStringFilter />
        </Stack>
        <FilterOptions />
      </Stack>
      <UsersTable />
    </Stack>
  );
};
